import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppraisalDetailsModelForCM } from "../../all_Interfaces";


interface InitialState {
    data: AppraisalDetailsModelForCM,
    error: string,
    loading: boolean
}
const initialState: InitialState =
{
    data: {} as AppraisalDetailsModelForCM,
    error: '',
    loading: false
}

const appraisalDetailsForUSAppraisalCMSlice = createSlice({
    name: "appraisalDetailsForCM",
    initialState,
    reducers: {
        updateAppraisalDetailsForCM(state, action: PayloadAction<AppraisalDetailsModelForCM>) {
            state.data = action.payload;
        },
    },
});

export const { updateAppraisalDetailsForCM } = appraisalDetailsForUSAppraisalCMSlice.actions;

export default appraisalDetailsForUSAppraisalCMSlice.reducer;